<div [ngClass]="{ 'edit-mode-enabled': editEnabled }">
    <div *ngIf="image">
      <img [src]="image" (click)="onImageClick()" data-bs-toggle="modal" data-bs-target="#modalImage" alt="Uploaded image" />
    </div>
  
    <div *ngIf="!image || editEnabled">
      <input
        [id]="inputId"
        hidden
        type="file"
        (change)="onFileSelected($event)"
        [disabled]="!permission"
      />
      <label [for]="inputId" class="replace-image-label" [ngClass]="{ 'disabled-label': !permission }">
        <img *ngIf="!image" src="../../../../assets/missing_image.png" alt="Missing image" />
        <ng-container *ngIf="editEnabled && image">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
            fill="none" stroke="#6c757d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="feather feather-edit">
            <title>Replace this photo</title>
            <path d="M12 20h9"></path>
            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 0l1 1a2.121 2.121 0 0 1 0 3L7 21H3v-4L16.5 3.5z"></path>
          </svg>
        </ng-container>
      </label>
    </div>
  </div>